import React from 'react';
import './PageStyles.css';

const Analytics: React.FC = () => {
  const metrics = [
    { label: 'Impressions', value: '2.4M', change: '+15.3%' },
    { label: 'Clicks', value: '84.2K', change: '+8.7%' },
    { label: 'CTR', value: '3.51%', change: '+2.1%' },
    { label: 'Conversions', value: '1,247', change: '+12.4%' }
  ];

  const platforms = [
    { name: 'Instagram', reach: '45.2K', engagement: '8.4%', color: '#E4405F' },
    { name: 'LinkedIn', reach: '32.1K', engagement: '6.7%', color: '#0077B5' },
    { name: 'Facebook', reach: '28.9K', engagement: '5.2%', color: '#1877F2' },
    { name: 'Twitter', reach: '19.7K', engagement: '4.8%', color: '#1DA1F2' },
    { name: 'TikTok', reach: '15.3K', engagement: '9.1%', color: '#000000' }
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Analytics</h1>
        <p className="page-subtitle">Track your network performance and engagement metrics</p>
        <div className="header-actions">
          <select className="time-range-selector">
            <option>Last 7 days</option>
            <option>Last 30 days</option>
            <option>Last 3 months</option>
            <option>Last year</option>
          </select>
          <button className="export-btn">Export Report</button>
        </div>
      </div>

      {/* Key Metrics */}
      <div className="metrics-row">
        {metrics.map((metric, index) => (
          <div key={index} className="metric-card">
            <div className="metric-label">{metric.label}</div>
            <div className="metric-value">{metric.value}</div>
            <div className="metric-change positive">{metric.change}</div>
          </div>
        ))}
      </div>

      {/* Charts Section */}
      <div className="analytics-grid">
        {/* Engagement Chart */}
        <div className="chart-card">
          <div className="chart-header">
            <h3>Engagement Over Time</h3>
            <div className="chart-legend">
              <span className="legend-item">
                <div className="legend-color" style={{backgroundColor: '#1DB584'}}></div>
                Engagement Rate
              </span>
            </div>
          </div>
          <div className="chart-area">
            <div className="line-chart-mock">
              <svg width="100%" height="200" viewBox="0 0 400 200">
                <path
                  d="M0,150 Q100,120 200,100 T400,80"
                  stroke="#1DB584"
                  strokeWidth="3"
                  fill="none"
                />
                <path
                  d="M0,150 Q100,120 200,100 T400,80 L400,200 L0,200 Z"
                  fill="url(#gradient)"
                  opacity="0.1"
                />
                <defs>
                  <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor="#1DB584" />
                    <stop offset="100%" stopColor="#1DB584" stopOpacity="0" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>

        {/* Platform Performance */}
        <div className="platform-card">
          <div className="chart-header">
            <h3>Platform Performance</h3>
          </div>
          <div className="platform-list">
            {platforms.map((platform, index) => (
              <div key={index} className="platform-item">
                <div className="platform-info">
                  <div className="platform-color" style={{backgroundColor: platform.color}}></div>
                  <div className="platform-name">{platform.name}</div>
                </div>
                <div className="platform-metrics">
                  <div className="platform-reach">{platform.reach} reach</div>
                  <div className="platform-engagement">{platform.engagement} engagement</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Top Content */}
        <div className="content-card">
          <div className="chart-header">
            <h3>Top Performing Content</h3>
          </div>
          <div className="content-list">
            {[
              { title: 'Summer Campaign Launch', platform: 'Instagram', engagement: '94.2K' },
              { title: 'Product Demo Video', platform: 'LinkedIn', engagement: '78.5K' },
              { title: 'Behind the Scenes', platform: 'TikTok', engagement: '65.1K' },
              { title: 'User Testimonial', platform: 'Facebook', engagement: '52.3K' }
            ].map((content, index) => (
              <div key={index} className="content-item">
                <div className="content-info">
                  <div className="content-title">{content.title}</div>
                  <div className="content-platform">{content.platform}</div>
                </div>
                <div className="content-engagement">{content.engagement}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Audience Demographics */}
        <div className="demographics-card">
          <div className="chart-header">
            <h3>Audience Demographics</h3>
          </div>
          <div className="demographics-chart">
            <div className="demo-section">
              <h4>Age Groups</h4>
              <div className="demo-bars">
                {[
                  { label: '18-24', percentage: 35 },
                  { label: '25-34', percentage: 42 },
                  { label: '35-44', percentage: 18 },
                  { label: '45+', percentage: 5 }
                ].map((group, index) => (
                  <div key={index} className="demo-bar">
                    <span className="demo-label">{group.label}</span>
                    <div className="demo-progress">
                      <div 
                        className="demo-fill" 
                        style={{width: `${group.percentage}%`}}
                      ></div>
                    </div>
                    <span className="demo-percentage">{group.percentage}%</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Analytics; 